/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { TrashIcon } from '@avila-tek/ui/src';
import { Region } from '../../models';

interface RegionsListProps {
  regions: Region[];
  setRegions: React.Dispatch<React.SetStateAction<Region[]>>;
}

function RegionsList({ regions, setRegions }: RegionsListProps) {
  const removeRegion = (index: number) => {
    setRegions((prev) => {
      const newRegions = [...prev];
      newRegions.splice(index, 1);
      return newRegions;
    });
  };

  const removeSubRegion = (regionIndex, subIndex: number) => {
    setRegions((prev) => {
      const newRegions = [...prev];
      newRegions[regionIndex].subRegions.splice(subIndex, 1);
      return newRegions;
    });
  };

  return (
    <ul className="md:ml-10 marker:text-purple-300 mx-10">
      {regions.map((region, index) => (
        <li key={index} className="list-disc">
          <div className="flex items-center  my-2">
            <span>{region.name}</span>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                removeRegion(index);
              }}
            >
              <TrashIcon className="w-5 h-5 text-danger-200" />
            </button>
          </div>
          <ul className="md:ml-10 marker:text-purple-300">
            {region.subRegions.map((subRegion, subIndex) => (
              <li key={subIndex} className="list-decimal ">
                <div className="flex items-center">
                  <span>{subRegion}</span>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      removeSubRegion(index, subIndex);
                    }}
                  >
                    <TrashIcon className="w-5 h-5 text-danger-200" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}

export default RegionsList;
